// extracted by mini-css-extract-plugin
export default {"input":"Input_input__+xIWo","file":"Input_file__vwz+S"};